import { Query } from '@apollo/client/react/components';
import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseQuery, DatabaseQueryVariables, DatabaseDocument } from '../../../../../gen-src/queries';
import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

type Database = Unpacked<DatabaseQuery['databases']>

export type DatabaseQueryWrapperProps = {
  readonly databaseId: string;
  readonly children: (result: Database) => React.ReactNode;
};

export const DatabaseQueryWrapper = (props: DatabaseQueryWrapperProps) => {

  const renderDatabaseData = React.useCallback(
    (data: DatabaseQuery): Readonly<React.ReactNode> => {
      const database = data.databases ? data.databases[0] : null;
      if (database) {
        return props.children(database);
      } else {
        return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
      }
    },
    [props]
  );

  return (
    <Query<DatabaseQuery, DatabaseQueryVariables>
      query={DatabaseDocument}
      variables={{
        databaseId: props.databaseId,
      }}
    >
      {result => <RenderQueryResult result={result} renderers={{
        renderLoading: () => <CenteredFadeInSpinner />,
        renderData: renderDatabaseData,
        renderNoData: renderNoData,
        renderDataWithError: createRenderDataWithErrorFunction(renderDatabaseData),
        renderError: renderError,
      }} />}
    </Query>

  );



}
